var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWorkstation = function SvgWorkstation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.602 7.666V19h12.987V7.666",
    stroke: "#7D80DA",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.5 11.102 2l10.101 8.5",
    stroke: "#7D80DA",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};
export { SvgWorkstation as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMyAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik00LjYwMiA3LjY2NlYxOWgxMi45ODdWNy42NjYiIHN0cm9rZT0iIzdEODBEQSIgc3Ryb2tlLXdpZHRoPSIyIi8+CiAgICA8cGF0aCBkPSJNMSAxMC41IDExLjEwMiAybDEwLjEwMSA4LjUiIHN0cm9rZT0iIzdEODBEQSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==";